import { render, staticRenderFns } from "./ModifyOrderingSubjects.vue?vue&type=template&id=014fac9c&"
import script from "./ModifyOrderingSubjects.vue?vue&type=script&lang=ts&"
export * from "./ModifyOrderingSubjects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports